import React from 'react';
import { PHASE, PHASE_API_MAP, PHASE_COLORS, PHASE_COLORS_MAP, PHASE_CONTRAST, toPhaseKey } from '../constants/colors';
import './PhaseBadge.css';

/**
 * Libellé et couleurs d'affichage d'une phase (`{ label, color, textColor }`), ou `null`
 * si la clé est inconnue. Partagé avec le bandeau de phase des cartes coach.
 */
export const phaseDisplay = (phase) => {
  const key = toPhaseKey(phase);
  const config = PHASE_COLORS[key];
  if (!config) return null;

  const color = PHASE_COLORS_MAP[PHASE_API_MAP[key]] || config.main;
  // Le vert folliculaire est illisible en texte sur fond clair : version foncée.
  const textColor = color === PHASE.folliculaire ? PHASE_CONTRAST.folliculaireDark : color;
  return { label: config.label, color, textColor };
};

/**
 * Puce « phase du cycle » : pastille + libellé sur fond teinté de la couleur de phase.
 *
 * `phase` est une clé du moteur (`REGLES`, `FOLLICULAIRE`… — telle que renvoyée par
 * `/cycles/sportive/{id}/phases`). Clé inconnue ou absente : rien n'est rendu, l'appelant
 * n'a pas à tester.
 */
const PhaseBadge = ({ phase, className = '' }) => {
  const display = phaseDisplay(phase);
  if (!display) return null;
  const { label, color, textColor } = display;

  return (
    <span
      className={`phase-badge ${className}`.trim()}
      style={{ '--phase-badge-color': color, color: textColor }}
      title={`Phase actuelle : ${label}`}
    >
      <span className="phase-badge__dot" aria-hidden="true" />
      {label}
    </span>
  );
};

export default PhaseBadge;
